//#region types
import { ChartEnums } from "models/enums";
import { GraphConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useWintSalaryService } from "serviceHooks";
//#endregion
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const GrossSalaryChart: React.FC<{ onChartSuccessHandler?: (data?: WintSuperkollAPIModel.ReportWidget) => void }> = ({
  onChartSuccessHandler,
}) => {
  const { reportToApiFilter } = useWintSalaryService();
  const labelFormatter = (label?: string) => (label ? label.substring(0, 3) : "");
  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Line}
      chartAPIKey={GraphConstants.ChartKeys.WintSalaryGrossSalaryPerMonthAccumulated}
      filterToAPIHandler={reportToApiFilter}
      labelFormatter={labelFormatter}
      usePageFilter
      onChartSuccessHandler={onChartSuccessHandler}
      yAxisTickUnit={ChartEnums.YAxisTickUnitType.Currency}
    />
  );
};

export default GrossSalaryChart;
